/**
 * Default column definitions for all entity list views.
 * Each column has: key, label, defaultVisible, locked, defaultOrder
 *
 * locked = true means the column cannot be hidden by the user (always visible).
 * defaultOrder determines initial left-to-right position (0-indexed).
 */

const ENTITY_TYPES = [
  'accounts',
  'contacts',
  'opportunities',
  'repFirms',
  'products',
  'quotes',
  'orders',
  'tasks',
];

const accountColumns = [
  { key: 'name', label: 'Account Name', defaultVisible: true, locked: true, defaultOrder: 0 },
  { key: 'is_key_account', label: 'Key', defaultVisible: true, locked: false, defaultOrder: 1 },
  { key: 'stage_name', label: 'Stage', defaultVisible: true, locked: false, defaultOrder: 2 },
  { key: 'industry', label: 'Industry', defaultVisible: true, locked: false, defaultOrder: 3 },
  { key: 'primary_owner', label: 'Primary Owner', defaultVisible: true, locked: false, defaultOrder: 4 },
  { key: 'lead_source_name', label: 'Lead Source', defaultVisible: true, locked: false, defaultOrder: 5 },
  { key: 'website', label: 'Website', defaultVisible: false, locked: false, defaultOrder: 6 },
  { key: 'country', label: 'Country', defaultVisible: false, locked: false, defaultOrder: 7 },
  { key: 'state', label: 'State', defaultVisible: false, locked: false, defaultOrder: 8 },
  { key: 'address', label: 'Address', defaultVisible: false, locked: false, defaultOrder: 9 },
  { key: 'created_at', label: 'Created', defaultVisible: false, locked: false, defaultOrder: 10 },
];

const contactColumns = [
  { key: 'first_name', label: 'First Name', defaultVisible: true, locked: true, defaultOrder: 0 },
  { key: 'is_key_contact', label: 'Key', defaultVisible: true, locked: false, defaultOrder: 1 },
  { key: 'last_name', label: 'Last Name', defaultVisible: true, locked: false, defaultOrder: 2 },
  { key: 'account_name', label: 'Account', defaultVisible: true, locked: false, defaultOrder: 3 },
  { key: 'email', label: 'Email', defaultVisible: true, locked: false, defaultOrder: 4 },
  { key: 'phone', label: 'Phone', defaultVisible: true, locked: false, defaultOrder: 5 },
  { key: 'job_title', label: 'Job Title', defaultVisible: true, locked: false, defaultOrder: 6 },
  { key: 'city', label: 'City', defaultVisible: false, locked: false, defaultOrder: 7 },
  { key: 'state', label: 'State', defaultVisible: false, locked: false, defaultOrder: 8 },
  { key: 'country', label: 'Country', defaultVisible: false, locked: false, defaultOrder: 9 },
  { key: 'active', label: 'Status', defaultVisible: true, locked: false, defaultOrder: 10 },
  { key: 'owner_name', label: 'Owner', defaultVisible: false, locked: false, defaultOrder: 11 },
  { key: 'rep_firm_name', label: 'Rep Firm', defaultVisible: false, locked: false, defaultOrder: 12 },
  { key: 'lead_source_name', label: 'Lead Source', defaultVisible: false, locked: false, defaultOrder: 13 },
  { key: 'created_at', label: 'Created', defaultVisible: false, locked: false, defaultOrder: 14 },
];

const opportunityColumns = [
  { key: 'name', label: 'Opportunity Name', defaultVisible: true, locked: true, defaultOrder: 0 },
  { key: 'account_name', label: 'Account', defaultVisible: true, locked: false, defaultOrder: 1 },
  { key: 'stage_name', label: 'Stage', defaultVisible: true, locked: false, defaultOrder: 2 },
  { key: 'amount', label: 'Amount', defaultVisible: true, locked: false, defaultOrder: 3 },
  { key: 'owner_name', label: 'Owner', defaultVisible: true, locked: false, defaultOrder: 4 },
  { key: 'expected_close_date', label: 'Expected Close', defaultVisible: true, locked: false, defaultOrder: 5 },
  { key: 'contact_name', label: 'Contact', defaultVisible: false, locked: false, defaultOrder: 6 },
  { key: 'rep_firm_name', label: 'Rep Firm', defaultVisible: false, locked: false, defaultOrder: 7 },
  { key: 'created_at', label: 'Created', defaultVisible: false, locked: false, defaultOrder: 8 },
];

const repFirmColumns = [
  { key: 'name', label: 'Name', defaultVisible: true, locked: true, defaultOrder: 0 },
  { key: 'phone', label: 'Phone', defaultVisible: true, locked: false, defaultOrder: 1 },
  { key: 'country', label: 'Country', defaultVisible: true, locked: false, defaultOrder: 2 },
  { key: 'state', label: 'State', defaultVisible: true, locked: false, defaultOrder: 3 },
  { key: 'website', label: 'Website', defaultVisible: false, locked: false, defaultOrder: 4 },
  { key: 'address', label: 'Address', defaultVisible: false, locked: false, defaultOrder: 5 },
  { key: 'created_at', label: 'Created', defaultVisible: false, locked: false, defaultOrder: 6 },
];

const productColumns = [
  { key: 'name', label: 'Name', defaultVisible: true, locked: true, defaultOrder: 0 },
  { key: 'sku', label: 'SKU', defaultVisible: true, locked: false, defaultOrder: 1 },
  { key: 'description', label: 'Description', defaultVisible: true, locked: false, defaultOrder: 2 },
  { key: 'price', label: 'Price', defaultVisible: true, locked: false, defaultOrder: 3 },
  { key: 'active', label: 'Status', defaultVisible: true, locked: false, defaultOrder: 4 },
  { key: 'created_at', label: 'Created', defaultVisible: false, locked: false, defaultOrder: 5 },
];

const quoteColumns = [
  { key: 'quote_number', label: 'Quote #', defaultVisible: true, locked: true, defaultOrder: 0 },
  { key: 'account_name', label: 'Account', defaultVisible: true, locked: false, defaultOrder: 1 },
  { key: 'total', label: 'Total', defaultVisible: true, locked: false, defaultOrder: 2 },
  { key: 'status', label: 'Status', defaultVisible: true, locked: false, defaultOrder: 3 },
  { key: 'created_at', label: 'Created', defaultVisible: true, locked: false, defaultOrder: 4 },
  { key: 'expiration_date', label: 'Expires', defaultVisible: true, locked: false, defaultOrder: 5 },
  { key: 'owner_name', label: 'Owner', defaultVisible: false, locked: false, defaultOrder: 6 },
  { key: 'rep_firm_name', label: 'Rep Firm', defaultVisible: false, locked: false, defaultOrder: 7 },
];

const orderColumns = [
  { key: 'order_number', label: 'Order #', defaultVisible: true, locked: true, defaultOrder: 0 },
  { key: 'account_name', label: 'Account', defaultVisible: true, locked: false, defaultOrder: 1 },
  { key: 'total', label: 'Total', defaultVisible: true, locked: false, defaultOrder: 2 },
  { key: 'status', label: 'Status', defaultVisible: true, locked: false, defaultOrder: 3 },
  { key: 'order_date', label: 'Order Date', defaultVisible: true, locked: false, defaultOrder: 4 },
  { key: 'created_at', label: 'Created', defaultVisible: false, locked: false, defaultOrder: 5 },
];

const taskColumns = [
  { key: 'title', label: 'Action Item', defaultVisible: true, locked: true, defaultOrder: 0 },
  { key: 'account_name', label: 'Account', defaultVisible: true, locked: false, defaultOrder: 1 },
  { key: 'opportunity_name', label: 'Opportunity', defaultVisible: true, locked: false, defaultOrder: 2 },
  { key: 'due_date', label: 'Due Date', defaultVisible: true, locked: false, defaultOrder: 3 },
  { key: 'assigned_to_name', label: 'Assigned To', defaultVisible: true, locked: false, defaultOrder: 4 },
  { key: 'status', label: 'Status', defaultVisible: true, locked: false, defaultOrder: 5 },
  { key: 'created_at', label: 'Created', defaultVisible: false, locked: false, defaultOrder: 6 },
];

const COLUMN_DEFAULTS = {
  accounts: accountColumns,
  contacts: contactColumns,
  opportunities: opportunityColumns,
  repFirms: repFirmColumns,
  products: productColumns,
  quotes: quoteColumns,
  orders: orderColumns,
  tasks: taskColumns,
};

/**
 * Returns the default column config for an entity type,
 * with visible and order fields set from defaults.
 */
function getDefaultColumns(entityType) {
  const defaults = COLUMN_DEFAULTS[entityType];
  if (!defaults) return [];
  return defaults.map(col => ({
    key: col.key,
    label: col.label,
    visible: col.defaultVisible,
    order: col.defaultOrder,
    locked: col.locked,
  }));
}

export { ENTITY_TYPES, COLUMN_DEFAULTS, getDefaultColumns };
